import React from 'react';
import { Reply, Trash2 } from '../../assets/AppIcons';
import { Button } from '../../ui/button';
import {
  formatCommentDate,
  getAuthorInitials,
  getCommentBody,
  getCommentCreatedAt,
  getCommentId,
  resolveCommentAuthor,
} from './commentThread.helpers';
import CommentComposer from './CommentComposer';

const ReplyIcon = Reply || (() => null);
const DeleteIcon = Trash2 || (() => null);

export default function CommentItem({
  comment,
  staff = [],
  currentUser,
  allowReplies = false,
  replyTargetId = null,
  replySubmittingTo = null,
  onStartReply,
  onCancelReply,
  onSubmitReply,
  onDeleteComment,
  disabled = false,
  level = 0,
}) {
  const commentId = getCommentId(comment);
  const authorName = resolveCommentAuthor(comment, { staff, currentUser });
  const replies = Array.isArray(comment.replies) ? comment.replies : [];
  const isReplying = String(replyTargetId) === String(commentId);
  const isReplySubmitting = String(replySubmittingTo) === String(commentId);

  return (
    <div className={`comment-item${level > 0 ? ' comment-item--reply' : ''}`}>
      <div className="comment-thread__avatar" aria-hidden="true">
        {getAuthorInitials(authorName)}
      </div>
      <div className="comment-item__main">
        <article className="comment-item__card">
          <header className="comment-item__header">
            <strong>{authorName}</strong>
            <time>{formatCommentDate(getCommentCreatedAt(comment))}</time>
          </header>
          <p>{getCommentBody(comment)}</p>
        </article>

        <div className="comment-item__actions">
          {allowReplies && level === 0 ? (
            <button type="button" onClick={() => onStartReply?.(comment)} disabled={disabled}>
              <ReplyIcon size={16} />
              Rispondi
            </button>
          ) : null}
          {onDeleteComment ? (
            <button type="button" onClick={() => onDeleteComment(comment)} disabled={disabled}>
              <DeleteIcon size={16} />
              Elimina
            </button>
          ) : null}
        </div>

        {isReplying ? (
          <div className="comment-item__reply-box">
            <div className="comment-item__reply-context">
              Risposta a {authorName}
              <Button type="button" variant="ghost" size="sm" onClick={onCancelReply} disabled={isReplySubmitting}>
                Annulla
              </Button>
            </div>
            <CommentComposer
              currentUser={currentUser}
              staff={staff}
              placeholder="Scrivi una risposta..."
              submitLabel="Invia risposta"
              compact
              disabled={disabled}
              isSubmitting={isReplySubmitting}
              onSubmit={(payload) => onSubmitReply?.(commentId, payload)}
            />
          </div>
        ) : null}

        {replies.length > 0 ? (
          <div className="comment-item__replies">
            {replies.map((reply) => (
              <CommentItem
                key={getCommentId(reply)}
                comment={reply}
                staff={staff}
                currentUser={currentUser}
                allowReplies={false}
                disabled={disabled}
                level={level + 1}
              />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
